import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastSnackbarComponent } from '../components/toast-snackbar/toast-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly snackBar = inject(MatSnackBar);

  success(title: string, description: string, value: number): void {
    this.snackBar.openFromComponent(ToastSnackbarComponent, {
      data: {
        title,
        description,
        isError: false,
      },
      duration: value,
      horizontalPosition: 'left',
      verticalPosition: 'bottom',
      panelClass: ['app-toast-snackbar-shell'],
    });
  }

  error(title: string, description: string, value: number): void {
    this.snackBar.openFromComponent(ToastSnackbarComponent, {
      data: {
        title,
        description,
        isError: true,
      },
      duration: value,
      horizontalPosition: 'left',
      verticalPosition: 'bottom',
      panelClass: ['app-toast-snackbar-shell'],
    });
  }
}
